import { useMutation, UseMutationOptions } from 'react-query';
import { RobotDevice } from '../../types';
import { triggerRobotFlow } from '../api';
import { RobotTutorial } from '../types';

export const useTriggerRobotFlow = (
  robot: RobotDevice | undefined,
  options?: UseMutationOptions<void, unknown, RobotTutorial['id'], unknown>
) => {
  const mutation = useMutation({
    mutationFn: async (robotTutorialId: RobotTutorial['id']) =>
      triggerRobotFlow(robot?.websocketConnection?.ipAddress, robotTutorialId),
    ...options,
  });

  return mutation;
};
